/**
 * Признак «прокручен с начала» для блоков, у которых ближний край
 * растворяется только после прокрутки (правило — в styles.css, «Прокрутка:
 * края»): ряды во всю ширину страницы — слева, списки — сверху.
 *
 * В покое у начала ничего не скрыто, и маска там не нужна — а маска на каждом
 * ряду главной это по лишнему слою на ряд. Поэтому признак ставит один
 * слушатель на весь документ: событие прокрутки не всплывает, но
 * перехватывается на погружении. Атрибут, а не класс: класс блока ведёт
 * React и при перерисовке затёр бы добавленный.
 */
const ROWS = '.rail, .cast-row, .genre-row';
const LISTS = '.tv-tiles-scroll, .tv-next-list, .channel-panel-list';

export function installScrollFade(): () => void {
  const onScroll = (event: Event): void => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const row = target.matches(ROWS);
    if (!row && !target.matches(LISTS)) return;
    const scrolled = (row ? target.scrollLeft : target.scrollTop) > 1;
    if (scrolled !== target.hasAttribute('data-scrolled')) target.toggleAttribute('data-scrolled', scrolled);
  };
  document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  return () => document.removeEventListener('scroll', onScroll, { capture: true });
}
